import { render, staticRenderFns } from "./refund-policy-en.component.vue?vue&type=template&id=1b030600&scoped=true"
import script from "./refund-policy-en.component.ts?vue&type=script&lang=ts&external"
export * from "./refund-policy-en.component.ts?vue&type=script&lang=ts&external"
import style0 from "./refund-policy-en.component.vue?vue&type=style&index=0&id=1b030600&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b030600",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b030600')) {
      api.createRecord('1b030600', component.options)
    } else {
      api.reload('1b030600', component.options)
    }
    module.hot.accept("./refund-policy-en.component.vue?vue&type=template&id=1b030600&scoped=true", function () {
      api.rerender('1b030600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/refundPolicy/refund-policy-en.component.vue"
export default component.exports